import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="logo">
          <span className="logo-icon">&#x1F3E0;</span>
          <span className="logo-text">SurrealEstate<span className="logo-accent">Search</span></span>
        </Link>
        <nav className="nav">
          <Link to="/" className="nav-link">Home</Link>
          <span className="nav-badge">Pillar 1</span>
          <span className="nav-badge nav-badge--soon">Pillar 2 – Soon</span>
        </nav>
      </div>
    </header>
  );
}
